import { z } from 'zod';
import { FlowDefinitionState } from './flowDefinition.js';
const IsoDateTimeFilterSchema = z.iso.datetime({ offset: true });
/**
 * Query parameters `GET /flow-definitions` accepts. Every value arrives as a string on the wire,
 * which is why the non-string filters coerce.
 */
export const ListFlowDefinitionsQuerySchema = z.object({
    name: z.string().describe('Return only definitions whose flow name matches this.').optional(),
    ids: z.array(z.string()).describe('Return only definitions with these ids.').optional(),
    flowId: z.uuid().describe('Return only definitions of this flow.').optional(),
    organizationId: z
        .union([z.array(z.uuid()), z.uuid()])
        .describe('Return only definitions in this organization, or in any of these organizations.')
        .optional(),
    agentId: z.uuid().describe('Return only definitions belonging to this agent.').optional(),
    createdBefore: IsoDateTimeFilterSchema.describe('Return only definitions created before this ISO-8601 timestamp.').optional(),
    createdAfter: IsoDateTimeFilterSchema.describe('Return only definitions created after this ISO-8601 timestamp.').optional(),
    createdByEmail: z.string().describe('Return only definitions created by this user.').optional(),
    state: z
        .enum(FlowDefinitionState)
        .describe('Return only definitions in this lifecycle state, such as Published or Draft.')
        .optional(),
    includeInactive: z.coerce
        .boolean()
        .describe('Include definitions of inactive flows.')
        .optional()
        .default(false),
    version: z.coerce.number().describe('Return only definitions at this version.').optional(),
    includesSubFlowDefinitionId: z
        .uuid()
        .describe('Return only definitions whose graph calls this subflow definition.')
        .optional(),
    limit: z.coerce.number().describe('How many definitions to return.').optional(),
    offset: z.coerce.number().describe('How many matches to skip, for paging.').optional(),
    orderBy: z.string().describe('Column to order by, such as created or name.').optional(),
    orderDirection: z.enum(['asc', 'desc']).describe('Direction to order by.').optional(),
    orderSpec: z
        .string()
        .describe('Comma-separated `column:direction` pairs, for ordering by more than one column.')
        .optional(),
});
/** Path parameters `GET /flow-definitions/{id}` accepts. */
export const GetFlowDefinitionByIdParamsSchema = z.object({
    id: z.string().describe('The flow definition id.'),
});
//# sourceMappingURL=flowDefinitionRequests.js.map